<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Chat Support"></app-sub-header>

                        <div class="card margin-b">

                            <div class="card-body margin-b">
                                <div class="border-b margin-b">
                                    <h5 class="card-title font-weight">Query Type</h5>
                                    <p *ngIf ="!loadingSupport"class="margin-b"><app-skelton></app-skelton></p>

                                    <p *ngIf ="loadingSupport"class="margin-b">{{ticketData?.title}}</p>

                                </div>

                                <div class="border-b margin-b">
                                    <h5 class="card-title font-weight">Email</h5>
                                    <p *ngIf ="!loadingSupport"class="margin-b"><app-skelton></app-skelton></p>

                                    <p *ngIf ="loadingSupport" class="margin-b">{{currentUser?.email}}</p>

                                </div>


                                <div class="border-b margin-b">
                                    <h5 class="card-title font-weight">Query</h5>
                                    <p *ngIf ="!loadingSupport"class="margin-b"><app-skelton></app-skelton></p>
                                    <p *ngIf ="loadingSupport"class="margin-b">{{ticketData?.description}}</p>
                                   

                                </div>

                                <div *ngIf="ticketData?.status == 'OPEN'" class="border-b">
                                    <div class="display" style="justify-content: flex-end;
                                    ">
                                        <button class="btn btn-color color btn-sm"
                                            (click)="changeStatus('CANCEL')">Cancel</button>
                                        <button class="btn btn-color color btn-sm  margin-l"
                                            (click)="changeStatus('RESOLVE')">Resolve</button>
                                    </div>
                                </div>

                                <div *ngIf="ticketData?.status == 'CANCEL'" class="border-b">
                                    <div class="display" style="justify-content: flex-end;
                                    ">
                                        <button class="btn btn-color color btn-sm">Canceled</button>
                                    </div>
                                </div>
                                <div *ngIf="ticketData?.status == 'RESOLVE'" class="border-b">
                                    <div class="display" style="justify-content: flex-end;
                                    ">
                                        <button class="btn btn-color color btn-sm">RESOLVED</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div>
                            <div class="main-backgroundcolor">
                                <div class="header color">
                                    Comments
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="row">
                    <div class="col-md-12">
                        <div class="card margin-b">
                            <div class="card-body" style="min-height: 350px;">

                                <div *ngIf="commentsArray.length == 0 && loading" class="header"
                                    style="text-align: center; padding: 175px 0;">

                                    <div style="font-size: 20px; color: #bdbdbd;">No comments to show...</div>
                                </div>



                                <div class="comment-box margin-b" *ngFor="let props of arr">

                                    <div *ngIf="!loading" class="display" style="justify-content:space-between">
                                        <div class="comment" style="background-color: #ebebeb;">
                                            <div class="display" style="justify-content: space-between;">
                                                <div class="user-name">
                                                    <h4>
                                                        <app-skelton></app-skelton>
                                                    </h4>
                                                </div>
                                                <div class="time-text">
                                                    <app-skelton></app-skelton>
                                                </div>
                                            </div>

                                            <div class="comment-text">
                                                <p>
                                                    <app-skelton></app-skelton>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="image-wrapper margin-l">
                                            <img [src]="">
                                        </div>
                                    </div>



                                </div>



                                <div class="comment-box margin-b" *ngFor="let props of loadMoreArr">

                                    <div *ngIf="loading" class="display" style="justify-content:space-between">
                                        <div class="comment">
                                            <div class="display" style="justify-content: space-between;">
                                                <div class="user-name">
                                                    <h4>{{props.name}}</h4>
                                                </div>
                                                <div class="time-text">{{getDate(props.createdAt)}}</div>
                                            </div>

                                            <div class="comment-text">
                                                <p>{{props.description}}</p>
                                            </div>
                                        </div>
                                        <div class="image-wrapper margin-l">
                                            <img [src]="props.photo" (error)="getErrorImage($event)">
                                        </div>
                                    </div>



                                </div>

                                <div *ngIf="showButton" style="padding: 0 250px;">

                                    <div class="icon" (click)="showMore()"><i title="Show more comments"
                                            class="fas fa-plus"></i>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="display">
                            <div class="input-group">
                                <input class="form-control" [(ngModel)]="comment" type="text"
                                    placeholder="Write Comment" (keyup.enter)="onSubmit()">
                                <span class="input-group-btn">
                                    <button type="submit" [disabled]="comment == ''"
                                        class="btn main-backgroundcolor color margin-l"
                                        (click)="onSubmit()">Send</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>